import React, { useState } from 'react';
import { useServiceWorker } from '../../hooks/use-service-worker';

export const ServiceWorkerDevPanel: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    isInitialized,
    isUpdateAvailable,
    currentVersion,
    isLoading,
    error,
    checkForUpdates,
    applyUpdate,
    clearCache,
    getCacheInfo,
    getWorkerStatus,
    resetError
  } = useServiceWorker();

  const [cacheInfo, setCacheInfo] = useState<any[]>([]);
  const [workerStatus, setWorkerStatus] = useState<any>(null);

  const handleGetCacheInfo = async () => {
    try {
      const info = await getCacheInfo();
      setCacheInfo(info);
    } catch (error) {
      console.error('Failed to get cache info:', error);
    }
  };

  const handleGetWorkerStatus = () => {
    const status = getWorkerStatus();
    setWorkerStatus(status);
  };

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="service-worker-dev-panel">
      {/* Collapsible Header */}
      <div 
        className="dev-panel-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>🔧 Service Worker Dev Panel</span>
        <span className="expand-icon">
          {isExpanded ? '▼' : '▶'}
        </span>
      </div>

      {/* Expandable Content */}
      {isExpanded && (
        <div className="dev-panel-content">
          {/* Status Information */}
          <div className="status-section">
            <h4>Status</h4>
            <div className="status-grid">
              <div><strong>Initialized:</strong> {isInitialized ? '✅' : '❌'}</div>
              <div><strong>Update Available:</strong> {isUpdateAvailable ? '🆕' : '✅'}</div>
              <div><strong>Current Version:</strong> {currentVersion || 'Unknown'}</div>
              <div><strong>Loading:</strong> {isLoading ? '⏳' : '✅'}</div>
            </div>
          </div>

          {/* Error Display */}
          {error && (
            <div className="error-section">
              <h4>Error</h4>
              <div className="error-message">{error}</div>
              <button onClick={resetError} className="btn btn-sm btn-outline-secondary">
                Clear Error
              </button>
            </div>
          )}

          {/* Actions */}
          <div className="actions-section">
            <h4>Actions</h4>
            <div className="action-buttons">
              <button 
                onClick={checkForUpdates}
                className="btn btn-primary"
                disabled={isLoading}
              >
                Check Updates
              </button>
              
              {isUpdateAvailable && (
                <button 
                  onClick={applyUpdate}
                  className="btn btn-success"
                  disabled={isLoading}
                >
                  Apply Update
                </button>
              )}
              
              <button 
                onClick={clearCache}
                className="btn btn-warning"
                disabled={isLoading}
              >
                Clear Cache
              </button>
              
              <button 
                onClick={handleGetCacheInfo}
                className="btn btn-info"
                disabled={isLoading}
              >
                Get Cache Info
              </button>
              
              <button 
                onClick={handleGetWorkerStatus}
                className="btn btn-secondary"
              >
                Get Worker Status
              </button>
            </div>
          </div>

          {/* Cache Information */}
          {cacheInfo.length > 0 && (
            <div className="cache-section">
              <h4>Cache Information</h4>
              <div className="cache-list">
                {cacheInfo.map((cache, index) => (
                  <div key={index} className="cache-item">
                    <strong>{cache.name}:</strong> {cache.size} entries
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Worker Status */}
          {workerStatus && (
            <div className="worker-status-section">
              <h4>Worker Status</h4>
              <div className="worker-status-info">
                <div><strong>Initialized:</strong> {workerStatus.isInitialized ? 'Yes' : 'No'}</div>
                <div><strong>State:</strong> {workerStatus.state || 'Unknown'}</div>
              </div>
            </div>
          )}
        </div>
      )}


    </div>
  );
};
